// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Button, NumberInput, Toastr } from "../../revvComponents";

// Internal Imports
import { BILLING } from "../../constants";
import { GlobalUtils } from "../../utils";

// Service import
import { sendFeatureRequest } from "../../actions/CommonActions/commonService";

// Action Imports
import { getSubscriptionCheckoutSessionID } from "../../actions/SettingsActions/settingsActions";

// Destructuring
const { PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION } = BILLING;
const { readDataFromLocalStorage } = GlobalUtils;

class ShowUserLimitIncreaseRequestPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toogleStatus: true,
      phoneNumber: "",
    };
  }

  _updateToggleStatus = data => {
    this.setState({
      toogleStatus: data !== "Monthly",
    });
  };

  _onPhoneNumberChange = value => {
    this.setState({
      phoneNumber: value,
    });
  };

  _onSubmit = () => {
    const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
    const body = `A user just requested a callback to increase user limit. Phone: ${this.state.phoneNumber}.
    The user's current plan is ${userSignUpInfo.billing_plan}`;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const {
      first_name: firstName,
      last_name: lastName,
      user_email: userEmail,
      organisation,
    } = CURRENT_USER;
    const data = {
      email: userEmail,
      orgname: organisation,
      subject: `Increase user limit call back request - Current plan: ${userSignUpInfo.billing_plan} `,
      body,
      username: `${firstName} ${lastName}`,
    };
    sendFeatureRequest(data)
      .then(() => {
        this.props.onClose("showUserConsumptionPopup", false);
        Toastr.showToastr({
          type: "success",
          message: "Successfully requested call back",
          timeout: 3000,
        });
      })
      .catch(err => {
        console.error("UpgradePopUp => _onSubmit", err);
      });
  };

  render() {
    const mapBymonthlyOrAnnually = this.state.toogleStatus
      ? "annually"
      : "monthly";
    return (
      <Modal
        open
        onClose={() => this.props.onClose("showUserConsumptionPopup", false)}
        center
        closeOnOverlayClick={false}
        className="">
        {this.props.billingInfo !== null &&
        this.props.billingInfo.subscription.status === "active" &&
        this.props.billingInfo.auto_downgraded === false ? (
          <div className="userlimitincreaserequest-container">
            <section className="userlimitincreaserequest-info-section">
              <div className="userlimitincreaserequest-welcome-msg">
                Wow! You now have {this.props.userConsumptionRecord.limit} or
                more users in your account, that&apos;s great.
              </div>
              <div className="userlimitincreaserequest-upsale-msg">
                Please share your phone number for us to enable more users.
                We&apos;ll connect with you shortly to get more details and
                assist. You can also contact our support via the in-app or write
                to us at{" "}
                <span className="userlimitincreaserequest-email-contact">
                  support@revv.so
                </span>
              </div>
            </section>

            <section className="userlimitincreaserequest-callback-section">
              <div className="userlimitincreaserequest-callback-txt">
                Please enter your phone number and we will get in touch with you
                soon
              </div>
              <div className="">
                <NumberInput
                  data-test="phoneNumber"
                  placeholder="Enter your phone number"
                  onChange={value => this._onPhoneNumberChange(value)}
                  value={this.state.phoneNumber}
                  autoFocus
                />
                <div className="userlimitincreaserequest-callback-actions">
                  <Button
                    type="four"
                    data-test="phoneNumber-submission"
                    className="btn btn-primary planchangerequest-submit-btn"
                    onClick={() => this._onSubmit()}
                    disabled={this.state.phoneNumber.length === 0}>
                    Submit
                  </Button>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="userlimitincreaserequest-container">
            <section className="userlimitincreaserequest-info-section">
              <div className="userlimitincreaserequest-welcome-msg">
                You`ve a team on Revv! You have{" "}
                {this.props.userConsumptionRecord.limit} or more users added in
                your account.
              </div>
              <div className="userlimitincreaserequest-upsale-msg">
                Upgrade now to add more users. Collaborate efficiently on
                documents to close them faster and use our role based access
                control to manage teammates.
              </div>
            </section>

            <div className="userlimitincreaserequest-toogle-container">
              <span
                className={`userlimitincreaserequest-plan-toogle-tab ${
                  !this.state.toogleStatus
                    ? "userlimitincreaserequest-plan-toogle-selected-item"
                    : ""
                }`}
                role="button"
                tabIndex={0}
                onClick={() => this._updateToggleStatus("Monthly")}
                onKeyPress={() => {}}>
                Monthly
              </span>
              <span
                className={`userlimitincreaserequest-plan-toogle-tab ${
                  this.state.toogleStatus
                    ? "userlimitincreaserequest-plan-toogle-selected-item"
                    : ""
                }`}
                role="button"
                tabIndex={0}
                onClick={() => this._updateToggleStatus("Annually")}
                onKeyPress={() => {}}>
                Annually
              </span>
            </div>
            <div className="userlimitincreaserequest-plans-saving-text">
              <i>
                {" "}
                <FontAwesomeIcon icon={["far", "badge-percent"]} />
              </i>
              Save upto 20% on Annual plans
            </div>
            <div className="userlimitincreaserequest-plan-container">
              {PRICING_PLAN_STRIPE_MENU_FOR_SUBSCRIPTION[
                mapBymonthlyOrAnnually
              ].map(data => (
                <section
                  className={`userlimitincreaserequest-plan-section ${
                    data.mostPopular ? "most-pupular" : ""
                  }`}>
                  {data.mostPopular && (
                    <div className="userlimitincreaserequest-plan-most-popular">
                      Most popular
                    </div>
                  )}

                  <div className="userlimitincreaserequest-plan-name">
                    {data.displayName}
                  </div>
                  <div className="userlimitincreaserequest-plan-value">
                    {data.planPrice}
                    <span className="userlimitincreaserequest-plan-value-month">
                      /month
                    </span>
                  </div>
                  <div className="userlimitincreaserequest-plan-billed-period">
                    {data.yearlyPrice}
                  </div>
                  <div className="userlimitincreaserequest-plan-subscribe-button">
                    <Button
                      data-test="plan-subscription"
                      className="plan-subscription-btn"
                      onClick={() =>
                        this.props.getSubscriptionCheckoutSessionID(
                          data.priceID,
                        )
                      }>
                      {data.buttonLabel}
                    </Button>
                  </div>
                  {data.featureEnabled.map(featureDetails => (
                    <div className="userlimitincreaserequest-plan-feature-list">
                      <i>
                        {" "}
                        <FontAwesomeIcon icon={["far", "check-circle"]} />
                      </i>{" "}
                      {featureDetails}
                    </div>
                  ))}
                </section>
              ))}
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { billingInfo } = state.CommonStore;

  return { billingInfo };
};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShowUserLimitIncreaseRequestPopup);
